import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const CANALES = [
  { value: "linkedin",  label: "LinkedIn" },
  { value: "email",     label: "Email" },
  { value: "whatsapp",  label: "WhatsApp" },
  { value: "telefono",  label: "Teléfono" },
  { value: "otro",      label: "Otro" },
];

const ProspeccionContactoModal = ({ prospectoId, contacto, onClose, onSaved }) => {
  const isEdit = contacto && contacto.id;
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({
    id:               contacto?.id              || "",
    nombre:           contacto?.nombre          || "",
    cargo:            contacto?.cargo           || "",
    email:            contacto?.email           || "",
    telefono:         contacto?.telefono        || "",
    whatsapp:         contacto?.whatsapp        || "",
    linkedin_url:     contacto?.linkedin_url    || "",
    canal_preferido:  contacto?.canal_preferido || "",
    es_principal:     contacto?.es_principal == 1 || contacto?.es_principal === "1" ? 1 : 0,
    notas:            contacto?.notas           || "",
  });

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nombre.trim()) return toast.error("El nombre es obligatorio");

    setSubmitting(true);
    try {
      const fd = new FormData();
      fd.append("prospecto_id", prospectoId);
      Object.entries(form).forEach(([k, v]) => fd.append(k, v ?? ""));
      const r = await axios.post(`${BASE}/prospectos_contactos_guardar.php`, fd);
      if (r.data?.success) {
        toast.success(isEdit ? "Contacto actualizado" : "Contacto agregado");
        if (onSaved) onSaved();
      } else {
        toast.error(r.data?.mensaje || "Error al guardar");
        setSubmitting(false);
      }
    } catch {
      toast.error("Error de conexión");
      setSubmitting(false);
    }
  };

  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={e => e.stopPropagation()}>
        <h2 style={{ margin: "0 0 18px", fontSize: 18, fontWeight: 700, color: "#9f0059" }}>
          {isEdit ? "Editar contacto" : "+ Nuevo contacto"}
        </h2>

        <form onSubmit={handleSubmit}>
          <Field label="Nombre *"><input style={inp} value={form.nombre} onChange={set("nombre")} autoFocus /></Field>
          <Row>
            <Field label="Cargo"><input style={inp} value={form.cargo} onChange={set("cargo")} /></Field>
            <Field label="Canal preferido">
              <select style={inp} value={form.canal_preferido} onChange={set("canal_preferido")}>
                <option value="">—</option>
                {CANALES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
              </select>
            </Field>
          </Row>
          <Row>
            <Field label="Email"><input type="email" style={inp} value={form.email} onChange={set("email")} /></Field>
            <Field label="LinkedIn URL"><input style={inp} value={form.linkedin_url} onChange={set("linkedin_url")} /></Field>
          </Row>
          <Row>
            <Field label="Teléfono"><input style={inp} value={form.telefono} onChange={set("telefono")} /></Field>
            <Field label="WhatsApp"><input style={inp} value={form.whatsapp} onChange={set("whatsapp")} /></Field>
          </Row>
          <Field label="Notas">
            <textarea style={{ ...inp, minHeight: 60, fontFamily: "inherit", resize: "vertical" }}
              value={form.notas} onChange={set("notas")} />
          </Field>
          <label style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 6, fontSize: 13, color: "#666", cursor: "pointer" }}>
            <input type="checkbox" checked={!!form.es_principal} onChange={(e) => setForm(f => ({ ...f, es_principal: e.target.checked ? 1 : 0 }))} />
            ⭐ Marcar como contacto principal
          </label>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 22 }}>
            <button type="button" onClick={onClose} style={btnSecondary} disabled={submitting}>Cancelar</button>
            <button type="submit" style={btnPrimary} disabled={submitting}>
              {submitting ? "Guardando…" : "Guardar"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const overlay = { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 20 };
const modal = { background: "#fff", borderRadius: 14, padding: "26px 30px", maxWidth: 560, width: "100%", maxHeight: "90vh", overflowY: "auto", boxShadow: "0 8px 32px rgba(0,0,0,0.18)" };
const inp = { width: "100%", padding: "9px 12px", border: "1.5px solid #e0d6dc", borderRadius: 8, fontSize: 13, color: "#222", background: "#fafafa", outline: "none", boxSizing: "border-box", fontFamily: "inherit" };
const btnPrimary = { padding: "10px 22px", background: "#9f0059", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: "pointer" };
const btnSecondary = { padding: "10px 22px", background: "#fff", color: "#666", border: "1.5px solid #e0d6dc", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer" };

const Field = ({ label, children }) => (
  <div style={{ marginBottom: 12 }}>
    <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#888", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 4 }}>{label}</label>
    {children}
  </div>
);
const Row = ({ children }) => (<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>{children}</div>);

export default ProspeccionContactoModal;
